import React from "react";
import LegacyFindPlayerPage from "./FindPlayerPage";

export default function FindPlayerPage(props) {
    return <LegacyFindPlayerPage {...props} />;
}
